import { defineSlotRecipe } from "@chakra-ui/react";

export const dialogSlotRecipe = defineSlotRecipe({
  base: {
    content: {
      borderBottomRadius: { base: "0", lg: "2xl" },
      borderRadius: "2xl",
      my: "var(--dialog-margin, var(--dialog-base-margin))",
    },
    description: {
      color: "text.fg_muted",
    },
  },
  className: "chakra-dialog",
  defaultVariants: {
    motionPreset: { base: "slide-in-bottom", lg: "scale" },
    placement: { base: "bottom", lg: "top" },
    size: { base: "bottom", lg: "md" },
  },
  slots: [
    "trigger",
    "backdrop",
    "positioner",
    "content",
    "title",
    "description",
    "closeTrigger",
    "header",
    "body",
    "footer",
    "backdrop",
  ],
  variants: {
    motionPreset: {
      none: {},
      scale: {
        content: {
          _closed: {
            animationName: "scale-out, fade-out",
          },
          _open: {
            animationName: "scale-in, fade-in",
          },
        },
      },
      "slide-in-bottom": {
        content: {
          _closed: {
            animationName: "slide-to-bottom, fade-out",
          },
          _open: {
            animationName: "slide-from-bottom, fade-in",
          },
        },
      },
      "slide-in-left": {
        content: {
          _closed: {
            animationName: "slide-to-left, fade-out",
          },
          _open: {
            animationName: "slide-from-left, fade-in",
          },
        },
      },
      "slide-in-right": {
        content: {
          _closed: {
            animationName: "slide-to-right, fade-out",
          },
          _open: {
            animationName: "slide-from-right, fade-in",
          },
        },
      },
      "slide-in-top": {
        content: {
          _closed: {
            animationName: "slide-to-top, fade-out",
          },
          _open: {
            animationName: "slide-from-top, fade-in",
          },
        },
      },
    },
    placement: {
      bottom: {
        content: {
          "--dialog-base-margin": "spacing.16",
          mx: "auto",
        },
        positioner: {
          alignItems: "flex-end",
        },
      },
      center: {
        content: {
          "--dialog-base-margin": "auto",
          mx: "auto",
        },
        positioner: {
          alignItems: "center",
        },
      },
      top: {
        content: {
          "--dialog-base-margin": "spacing.16",
          mx: "auto",
        },
        positioner: {
          alignItems: "flex-start",
        },
      },
    },
    size: {
      bottom: {
        content: {
          mb: "0",
          w: "100dvw",
        },
      },
      md: {
        content: {
          maxW: "lg",
          mb: "var(--dialog-margin, var(--dialog-base-margin))",
        },
      },
    },
  },
});
